<template>
  <div class="container">
    <div class="titleone">测试号</div>
    <div class="tips">*内测中，暂未开放，敬请期待</div>
    <input
      type="text"
      class="form_input"
      v-model="patientsName"
      placeholder="请输入测试号"
    />
    <input
      type="text"
      class="form_input"
      v-model="password"
      placeholder="请输入密码"
    />
    <van-button
      type="primary"
      size="large"
      color="rgb(4,204,164)"
      @click="getData"
      >登录</van-button
    >
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      patientsName: null,
      password: null,
      hosLogo: null,
    }
  },
  mounted() {},
  methods: {
    getData() {
      if (this.patientsName == '123' && this.password == 'as123456') {
        this.$router.push('index')
      } else {
        Toast.fail('密码错误')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.van-button--large {
  width: 90%;
  height: 40px;
  margin-top: 40px;
}
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  .aslogo {
    width: 25vw;
    height: 25vw;
    margin-bottom: 10px;
  }
  .titleone {
    width: 100%;
    font-size: 22px;
    text-align: center;
  }
  .titletwo {
    margin-top: 10px;
    width: 100%;
    font-size: 20px;
    text-align: center;
    margin-bottom: 30px;
  }
}

input {
  margin-top: 20px;
  width: 90%;
  font-size: 15px;
  padding: 15px 0;
  /* 设置输入框中字体的大小 */

  /* 设置输入框的高度 */

  background: rgb(241, 241, 241);

  border: 0;
  /* 设置输入框边框的粗细和颜色 */

  color: #111;
  /* 设置输入框中文字的颜色 */

  outline: 0;
  /* 将输入框点击的时候出现的边框去掉 */

  text-align: left;
  /* 设置输入框中文字的位置 */

  padding-left: 20px;

  display: block;
  /* 将输入框设置为块级元素 */

  cursor: pointer;
}

input::-webkit-input-placeholder {
  color: rgb(199, 199, 199);
  font-size: 15px;
}
.tips {
  text-align: center;
  color: red;
  margin: 10px 0;
}
</style>
